var _slicedToArray = require("/var/www/aelpida/frontend/node_modules/@babel/runtime/helpers/slicedToArray");

function ___$insertStyle(css) {
  if (!css) {
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var PropTypes = require('prop-types');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

___$insertStyle(".cookie-banner {\n  position: fixed;\n  bottom: 0;\n  padding: 1.2em 2.074em;\n  font-size: 16px;\n  z-index: 9999;\n  background: #393939;\n  width: 100%;\n  color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n@media screen and (min-width: 768px) {\n  .cookie-banner {\n    flex-direction: row;\n  }\n}\n.cookie-banner__text {\n  flex-grow: 1;\n}\n.cookie-banner__link {\n  margin-left: 0.579em;\n}\n.cookie-banner__button {\n  padding: 0.694em 1.44em;\n  line-height: 1;\n  border: none;\n  background-color: #e8e81d;\n  margin-top: 1.2em;\n}\n@media screen and (min-width: 768px) {\n  .cookie-banner__button {\n    margin-top: 0;\n  }\n}\n.cookie-banner__button:hover {\n  cursor: pointer;\n  opacity: 0.9;\n}\n.cookie-banner__button:focus {\n  opacity: 0.6;\n  border: none;\n  outline: none;\n}\n.cookie-banner__button:active {\n  opacity: 0.4;\n}"); // TODO: Styled components would be cleaner and allow to override hovered link color


var defaultProps = {
  styles: {
    backgroundColor: '#393939',
    textColor: '#ffffff',
    link: {
      normalColor: '#e8e81d'
    },
    button: {
      backgroundColor: '#e8e81d',
      textColor: '#393939'
    }
  }
};

var CookieBanner = function CookieBanner(_ref) {
  var infoText = _ref.infoText,
      link = _ref.link,
      buttonText = _ref.buttonText,
      styles = _ref.styles;
  styles = Object.assign(defaultProps.styles, styles);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isAccepted = _React$useState2[0],
      setIsAccepted = _React$useState2[1];

  React.useEffect(function () {
    setIsAccepted(localStorage.getItem('cookieBanner:status') === 'accept');
  }, [isAccepted]);

  var handleAccept = function handleAccept() {
    localStorage.setItem('cookieBanner:status', 'accept');
    setIsAccepted(true);
  };

  if (isAccepted) return null;
  return React__default['default'].createElement('div', {
    className: "cookie-banner",
    style: {
      backgroundColor: styles.backgroundColor,
      color: styles.textColor
    }
  }, [React__default['default'].createElement('div', {
    className: "cookie-banner__text"
  }, [React__default['default'].createElement('span', {
    className: "cookie-banner__info"
  }, [infoText]), React__default['default'].createElement('a', {
    className: "cookie-banner__link",
    href: link.href,
    style: {
      color: styles.linkColor
    }
  }, [link.text])]), React__default['default'].createElement('button', {
    className: "cookie-banner__button",
    type: "button",
    onClick: handleAccept,
    style: {
      backgroundColor: styles.button.backgroundColor,
      color: styles.button.textColor
    }
  }, [buttonText])]);
};

CookieBanner.defaultProps = defaultProps;
CookieBanner.propTypes = {
  infoText: PropTypes__default['default'].string,
  link: PropTypes__default['default'].shape({
    href: PropTypes__default['default'].string,
    text: PropTypes__default['default'].string
  }),
  buttonText: PropTypes__default['default'].string,

  /** Colors in css syntax fe. `#000000` */
  styles: PropTypes__default['default'].shape({
    backgroundColor: PropTypes__default['default'].string,
    textColor: PropTypes__default['default'].string,
    link: PropTypes__default['default'].shape({
      normalColor: PropTypes__default['default'].string // TODO: Add hover color

    }),
    linkColor: PropTypes__default['default'].string,
    button: PropTypes__default['default'].shape({
      backgroundColor: PropTypes__default['default'].string,
      textColor: PropTypes__default['default'].string
    })
  })
};
exports.default = CookieBanner;